export const TAXONOMIES_WHITELIST = [
  'Depression',
  'Executives',
  'Wellness',
  'Trauma',
  'Non 12 Step',
  'Eating Disorders',
  'Adolescent',
  'Insurance Accepted',
  'Co-Occurring Disorders',
  'Christian',
  'Equine Therapy',
  'Detox',
  'Sober Living',
  'Anger',
  'Schizophrenia',
  'Outpatient Program',
  'BlueCross BlueShield',
  'Luxury'
]
